/**
 * @group API Handler
 * @summary <blockquote>Main export file for the API Handler package.</blockquote>
 * 
 * This package provides a cross-platform API client implementation using the fetch API,
 * compatible with both web and mobile (React Native) environments.
 * 
 * @example
 * ```typescript
 * import { FetchApiClient } from '@shared/httpService';
 * 
 * const apiClient = new FetchApiClient({
 *   baseURL: 'https://api.example.com',
 *   timeout: 5000
 * });
 * 
 * const users = await apiClient.get('/users');
 * ```
 */

// Export all types
export * from './types';

// Export all interfaces
export * from './interfaces';

// Export all classes
export * from './classes';

// Export all constants
export * from './constants';

// Export all utilities
export * from './utils';

// Export all services
export * from './services';
